module.exports = __webpack_public_path__ + "static/media/ow2ll14.af90b569.png";